import React, { useEffect, useState } from 'react';
import { FileText, Instagram, Linkedin } from 'lucide-react';
import './App.css';
import PDFUploader from './components/PDFUploader';
import AppLayout from './components/AppLayout';
import logo from './Imagens/logo.png';
import { api } from './services/api';


const LOGO_URL = logo;

function App() {
  const [pdfData, setPdfData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const baseURL = api?.defaults?.baseURL;
    if (!baseURL) return;

    
    api.get('/health', { timeout: 15000 }).catch(() => {});
  }, []);

  const handlePDFUploaded = (data) => {
    setPdfData(data);
    setCurrentPage(1);
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1 className="App-brand">
          {LOGO_URL ? (
            <img className="App-logo" src={LOGO_URL} alt="PDF AI" />
          ) : (
            <FileText size={28} style={{ marginRight: '10px', verticalAlign: 'middle' }} />
          )}
          <span>PDF AI</span>
        </h1>
      </header>

      <main className="App-main">
        {!pdfData ? (
          <PDFUploader onUpload={handlePDFUploaded} />
        ) : (
          <AppLayout
            pdfData={pdfData}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
          />
        )}
      </main>

      <footer className="App-footer">
        <div className="App-footer-inner">
          <div className="App-footer-text">
            Desenvolvido por <strong>Kaique</strong>
          </div>

          <div className="App-footer-social">
            <a
              href="https://www.instagram.com/lkayky_g?igsh=ZXB6ZTMzcTFnNHN5"
              target="_blank"
              rel="noreferrer noopener"
              aria-label="Instagram"
              title="Instagram"
            >
              <Instagram size={18} />
            </a>
            <a
              href="https://www.linkedin.com/in/kaiquegoncalves/"
              target="_blank"
              rel="noreferrer noopener"
              aria-label="LinkedIn"
              title="LinkedIn"
            >
              <Linkedin size={18} />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;

